import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { LiteratureDataService } from '../../services/literature-data.service';
import { ApiUrls } from '../../../../../../src/app/services/app-state.service';
import {
  LiteratureData,
  LiteratureDocument,
  LiteratureDocumentData,
  SegmentId,
} from '@types';
import { SegmentService } from '@services/segment.service';
import { LiteratureContentDocument } from '@types';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';

@Injectable({
  providedIn: 'root',
})
export class TopFormService {
  data$: Observable<LiteratureData>;
  apiUrls?: ApiUrls;
  constructor(
    private literatureDataService: LiteratureDataService,
    private segmentService: SegmentService,
    private literatureConfig: LiteratureGlobalConfigService
  ) {}

  /**
   *
   * @param params litCodes
   * @param literatureContentDocument literature documents
   * @returns list of documents with the passed litCode
   */
  populate(
    params: Map<string, string>,
    literatureContentDocument: LiteratureContentDocument[]
  ): Observable<LiteratureDocument[]> {
    return this.literatureDataService.loadData(params, false, true).pipe(
      map((data: LiteratureData) =>
        data?.document?.map((item) => this.modifyFeaturedData(item))
      ),
      map((data: LiteratureDocument[]) =>
        this.literatureDataService.getContentLiteratureDocumentsForDisplay(
          data,
          literatureContentDocument
        )
      ),
      shareReplay(1)
    );
  }

  modifyFeaturedData(data: LiteratureDocumentData): LiteratureDocument {
    const detailData = this.literatureDataService.literatureMapper(data);
    this.literatureDataService.mapLiteratureUrl(detailData);
    if (SegmentId.INVESTOR === this.segmentService.getCurrentSegmentId()) {
      detailData.isInvestor = true;
    }
    return detailData;
  }

  linkToNavigateDetailPage(literatureCode: string): string {
    return `${this.literatureConfig?.navigationUrls?.litDetailUrl}/${literatureCode}`;
  }
}
